import React from 'react';
import EduBanner from './EduBanner';
import EduAustraliaDetails from './EduAustraliaDetails';
import EduBannerTwo from './EduBannerTwo';

const EduAustralia = () => {
    return (
        <div>
            <EduBanner/>
            <EduAustraliaDetails/>
            <EduBannerTwo/>
        </div>
    );
};

export default EduAustralia;